var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocationPoiMarker = function SvgLocationPoiMarker(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2018_5121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4854 7.18131C27.6885 9.38415 28.9485 12.3575 28.999 15.4725C29.0496 18.5876 27.8866 21.6002 25.7561 23.8733L25.4854 24.1533L19.8281 29.8093C19.1102 30.5267 18.0144 31.2999 17.0001 31.3333C15.9858 31.3667 15.1289 30.6579 14.3654 29.9893L14.1734 29.8093L8.51474 24.152C6.26429 21.9015 5 18.8493 5 15.6666C5 12.484 6.26429 9.43176 8.51474 7.18131C10.7652 4.93086 13.8175 3.66656 17.0001 3.66656C20.1827 3.66656 23.235 4.93086 25.4854 7.18131Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2018_5121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3641 9.63599C25.0164 11.2881 25.9614 13.5181 25.9993 15.8544C26.0372 18.1907 25.1649 20.4502 23.5671 22.155L23.3641 22.365L19.1211 26.607C18.5827 27.145 17.8599 27.4583 17.0992 27.4834C16.3385 27.5084 15.5967 27.2434 15.0241 26.742L14.8801 26.607L10.6361 22.364C8.94822 20.6762 8 18.387 8 16C8 13.613 8.94822 11.3238 10.6361 9.63599C12.3239 7.94816 14.6131 6.99994 17.0001 6.99994C19.387 6.99994 21.6762 7.94816 23.3641 9.63599ZM17.0001 13C16.6061 13 16.216 13.0776 15.852 13.2284C15.488 13.3791 15.1573 13.6001 14.8787 13.8787C14.6002 14.1572 14.3792 14.488 14.2284 14.8519C14.0777 15.2159 14.0001 15.606 14.0001 16C14.0001 16.394 14.0777 16.7841 14.2284 17.148C14.3792 17.512 14.6002 17.8427 14.8787 18.1213C15.1573 18.3999 15.488 18.6209 15.852 18.7716C16.216 18.9224 16.6061 19 17.0001 19C17.7957 19 18.5588 18.6839 19.1214 18.1213C19.684 17.5587 20.0001 16.7956 20.0001 16C20.0001 15.2043 19.684 14.4413 19.1214 13.8787C18.5588 13.3161 17.7957 13 17.0001 13Z",
    fill: "url(#paint0_linear_2018_5121)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2018_5121",
    x: 0,
    y: 0.666565,
    width: 36.0007,
    height: 39.6679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.262745 0 0 0 0 0.419608 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2018_5121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2018_5121",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2018_5121",
    x1: 17.0002,
    y1: 6.99994,
    x2: 17.0002,
    y2: 27.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1565C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2196F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2018_5121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(5 5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPoiMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "locationPOIMarker.362d85bea2d2c2b33ad383a58a62c5cc.svg";